import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Check } from 'lucide-react';

const plans = [
  {
    id: 'starter',
    name: 'Starter',
    price: '19 €',
    period: '/mois',
    subtitle: 'Pour démarrer et tester',
    features: [
      '5 dossiers / mois',
      '5 analyses OCR / mois',
      'PDF max 10 MB',
      'Prédiagnostic complet',
      'Export PDF',
    ],
    popular: false,
  },
  {
    id: 'core',
    name: 'Core',
    price: '39 €',
    period: '/mois',
    subtitle: 'Pour une recherche active',
    features: [
      '15 dossiers / mois',
      '15 analyses OCR / mois',
      'PDF max 50 MB',
      'Next steps guidés',
      'Partage sécurisé',
    ],
    popular: true,
  },
  {
    id: 'pro',
    name: 'Pro',
    price: '69 €',
    period: '/mois',
    subtitle: 'Pour les repreneurs très actifs',
    features: [
      'Dossiers illimités',
      '50 analyses OCR / mois',
      'PDF max 50 MB',
      'Support prioritaire',
      'Partage sécurisé',
    ],
    popular: false,
  },
];

export function PricingSection() {
  return (
    <section className="py-16 md:py-24 bg-muted/30">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Plans & Tarifs
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Choisissez le plan adapté à votre rythme de recherche. Sans engagement.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {plans.map((plan) => (
            <Card 
              key={plan.id}
              className={`relative flex flex-col transition-all ${
                plan.popular 
                  ? 'border-accent shadow-lg scale-[1.02]' 
                  : 'border-border hover:border-accent/30'
              }`}
            >
              {plan.popular && (
                <Badge 
                  className="absolute -top-3 left-1/2 -translate-x-1/2 bg-accent text-accent-foreground text-xs"
                >
                  Recommandé
                </Badge>
              )}
              
              <CardHeader className="text-center pb-2">
                <CardTitle className="text-xl">{plan.name}</CardTitle>
                <CardDescription>{plan.subtitle}</CardDescription>
              </CardHeader>
              
              <CardContent className="flex-1 flex flex-col">
                <div className="text-center mb-6">
                  <span className="text-4xl font-bold">{plan.price}</span>
                  <span className="text-muted-foreground">{plan.period}</span>
                </div>
                
                <ul className="space-y-3 mb-6 flex-1">
                  {plan.features.map((feature, index) => (
                    <li key={index} className="flex items-center gap-2 text-sm">
                      <Check className="h-4 w-4 text-accent shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                
                <Link to="/pricing" className="w-full">
                  <Button 
                    className="w-full" 
                    variant={plan.popular ? 'default' : 'outline'}
                  >
                    Choisir ce plan
                  </Button>
                </Link>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
